import styles from "../../../layouts/OnboardLayout/OnboardLayout.module.scss";
import logo from "../../../../assets/logos/text-logo-black.svg";
import { useFormik } from "formik";
import Password from "../../../common/Formik/Password/Password";
import Button from "../../../common/Button/Button";
import passwordStyles from "./SetNewPassword.module.scss";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../routes";
import { Form } from "react-bootstrap";
import React from "react";
import * as Yup from "yup";
import { Messages } from "../../../../utils/constants";
import { validationMessage } from "../../../../Helper/helperfunction";
import { setPasswordSignUpAction } from "../../../../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import { getCode } from "country-list";

const SetNewPassword = () => {
  const history = useNavigate();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const saveSignUpDetail = useSelector((state) => state?.persist?.signUpData);

  const validationSchema = Yup.object({
    password: Yup.string()
      .required(validationMessage("Password"))
      .min(8, Messages?.passwordOfSixCharacters)
      .matches(Messages?.passwordTextChar, Messages?.passwordCharacters)
      .max(40, Messages?.passwordMaxCharacters),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], Messages?.passwordMustMatch)
      .required(validationMessage("Confirm Password")),
  });

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const isUSCitizen = saveSignUpDetail?.isUSCitizen === "Yes";
      const data = {
        firstName: saveSignUpDetail?.fname,
        lastName: saveSignUpDetail?.lname,
        email: saveSignUpDetail?.email,
        username: saveSignUpDetail?.username,
        password: values.password,
        partneroCustomerKey: saveSignUpDetail?.partneroCustomerKey,
        isUSCitizen,
      };
      if (!isUSCitizen && saveSignUpDetail?.country) {
        data.country = saveSignUpDetail.country;
       
      }
      if (window.po && typeof window.po === "function") {
        try {
          window.po("event", "set_password");
        } catch (error) {
        }
      } else {
        console.warn("⚠️ Partnero 'po' function not found on window.");
      }

      try {
        const response = await dispatch(setPasswordSignUpAction(data));

        if (response?.status === 200) {
          history(ROUTES.LOGIN);
        }
      } catch (error) {
        console.error("🚨 Error submitting password sign-up:", error);
      }
    },
  });

 

  return (
    <div className={`${styles.onboard_box} ${passwordStyles.password_box}`}>
      <Button
        variant='without_bg_border'
        className='backbtn'
        type="button"
        onClick={() => navigate(-1)}
      >
        <LeftArrowIcon />
        Back
      </Button>
      <h2>Set Password</h2>
      <p className={`${styles.sub_text} ${passwordStyles.sub_text}`}>
        Description: Use uppercase, lowecase, number and special characters
      </p>

      <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
        <Password
          control="input"
          type="text"
          name="password"
          label="Password"
          placeholder="Enter Your Password"
          className={styles.input}
          formik={formik}
          {...formik.getFieldProps("password")}
        />
        <Password
          control="input"
          type="text"
          name="confirmPassword"
          label="Confirm Password"
          placeholder="Enter Your Password"
          className={styles.input}
          formik={formik}
          {...formik.getFieldProps("confirmPassword")}
        />
        <div className={`${styles.submit_btn} mb-0`}>
          <Button
            fluid
            type="button"
            onClick={(e) => {
              formik.handleSubmit(e);
            }}
            disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting}
          >
            {formik.isSubmitting ? "Processing..." : "Continue"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SetNewPassword;
